module.exports = __webpack_public_path__ + "img/banner.b0be1135.png";